import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { REGEX } from '@core/validation';
import { POST_TYPE_KEY } from '@constants/constant'
@Pipe({
  name: 'bioLink'
})
export class BioLinkPipe implements PipeTransform {
  transform(text: string): string {
    return text?.replace(
      REGEX.WEBSITE_URL_PATTERN,
      `<a (click)='loadOtherPage(url);' href='void:javascript(0)'>$1</a>`
    );
  }
}
@Pipe({
  name: 'bioFormat'
})
export class BioFormatPipe implements PipeTransform {
  transform(text?): string {
    if (text?.length) {
      return text?.replaceAll('\n', '<br> ');
    }
    return '';
  }
}

@Pipe({
  name: 'hashtagFormat'
})
export class MakeTagTextPipe implements PipeTransform {
  constructor(private readonly _sanitizer: DomSanitizer) {}

  transform(text, items) {
    let tags = [];
    const userTags = items?.user_tag || items?.user_tags;
    if (userTags?.length) {
      tags = Array.from(new Set([...userTags]));
    }
    if (tags.length) {
      tags?.forEach((ele) => {
        const hashTag = `#${ele?.trim()}`;
        if (items.type !== POST_TYPE_KEY.ARTICLE) {
          text = text?.replaceAll(
            new RegExp(`${hashTag}(?=\\s|$)`, 'gi'),
            `<a class='clickToHashTag@#${hashTag}'>${hashTag}</a>`
          );
        }
      });
    }
    if (text) {
      return this._sanitizer.bypassSecurityTrustHtml(text);
    } else {
      return this._sanitizer.bypassSecurityTrustHtml('');
    }
  }
}

@Pipe({
  name: 'makeTextWithAdminTags'
})
export class MakeTagTextWithAdminTagPipe implements PipeTransform {
  transform(text, items) {
    return (
      items?.admin_tag?.reduce((acc, elem) => `${acc} #${elem}`, text) ??
      text ??
      ''
    );
  }
}
